import React, { useCallback, useState } from 'react';
import { Form } from 'react-form';
import { useDispatch } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { asyncSearchForSaveV2 } from '../../../../actions/saved-lists-actions';
import { savedListTypes } from '../../../../utils';
import {
    Input,
} from '../../../Form';
import styles from './createListForm.scss';

const CreateListForm = (props) => {
    const [state, setState] = useState({ selectedOption: [], selectOptions: [] });
    const { onCancel, onSubmit, errorMessage, listType, listFor = '', power6SortField } = props;
    const { selectedOption } = state;
    const selectPlaceholder = `Add ${(props.listType === savedListTypes.players.key ? 'Players' : 'Schools')}`;

    const dispatch = useDispatch();

    const handleChange = (selected) => {
        let optSelected = [];
        optSelected = selected.map((opt) => {
            return { playerSchoolId: opt.value };
        });
        setState({ ...state, selectedOption: optSelected });
    };

    const getOptions = useCallback(async (inputValue) => {
        const value = inputValue;
        if (value === '') {
            return [];
        }
        const searchResponse = await dispatch(asyncSearchForSaveV2({ value, listType, power6SortField }));
        let suggestions = [];
        if (searchResponse.hits) {
            suggestions = searchResponse.hits.map(p => {
                let searchOption = {};
                if (p.source.displayName) {
                    searchOption = { label: p.source.displayName, value: p.source.id };
                } else {
                    searchOption = { label: p.source.name, value: p.source.id };
                }
                return searchOption;
            });
        }
        setState(prevState => ({ ...prevState, selectOptions: suggestions }));
        return suggestions;
    }, []);

    return (
        <div>
            <Form
                onSubmit={values => onSubmit(values, selectedOption)}
            >
                {(formApi) => {
                    const { submitForm } = formApi;
                    return (
                        <form
                            onSubmit={submitForm}
                            className={`${styles.createList}`}
                        >
                            <h6 className={`${styles.title}`} data-testid="list-dropdown.create-list.title">
                                Create List
                            </h6>
                            <div className={`row`}>
                                <div className="col-12">
                                    <Input
                                        id={`listNameInput`}
                                        field={`listName`}
                                        placeholder="List name"
                                        label="List name"
                                        hiddenLabel={true}
                                        data-testid="list-dropdown.create-list.list-name-input"
                                    />
                                </div>
                                <div className={`col-12 ${listFor === 'manageList' ? 'd-none' : ''}`}>
                                    <AsyncSelect
                                        isMulti
                                        components={{ DropdownIndicator: null }}
                                        cacheOptions={false}
                                        loadOptions={getOptions}
                                        options={state.selectOptions}
                                        closeMenuOnSelect={true}
                                        placeholder={selectPlaceholder}
                                        className={'input-wrapper'}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {errorMessage && <div className="error-text" data-testid="list-dropdown.create-list.error-message">{errorMessage}</div>}

                            <div className={`text-right ${styles.buttonContainer}`}>
                                <button
                                    type="button"
                                    className={`btn btn-default btn-sm text-uppercase ${styles.button}`}
                                    onClick={onCancel}
                                    data-testid="list-dropdown.create-list.cancel-btn"
                                >
                                    Cancel
                                </button>
                                <button
                                    className={`btn btn-primary btn-sm text-uppercase ${styles.button}`}
                                    type="submit"
                                    data-testid="list-dropdown.create-list.save-btn"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

export default CreateListForm;
